import React from "react";

import { createTheme, ThemeProvider } from "@mui/material";

import { MuiTheme, MyGlobalStyles } from "../../theme";

export interface MyThemeProviderProps {
    children: React.ReactNode;
}

export const MyThemeProvider = ({ children }: MyThemeProviderProps) => {
    const theme = createTheme(MuiTheme);

    return (
        <>
            <MyGlobalStyles />
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </>
    );
};
